import React from 'react';
import ReactDOM from 'react-dom';

//ko.bindingHandlers.react = {
//    init() {
//        return { controlsDescendantBindings: true };
//    },
//    update(element, valueAccessor) {
//        const { component, props } = valueAccessor();
//        ReactDOM.render(React.createElement(component, props), element);
//    }
//};
ko.bindingHandlers.react = {
    init: function (element) {
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            ReactDOM.unmountComponentAtNode(element);
        });

        return {
            controlsDescendantBindings: true
        };
    },

    update: function (element, valueAccessor, allBindings) {
        var options = ko.unwrap(valueAccessor());

        if (options && options.component) {
            var componentInstance = ReactDOM.render(
                React.createElement(options.component, options.props),
                element
            );

            if (options.ref) {
                options.ref(componentInstance);
            }
        }
    }
};